import React from 'react'
import LDTemplate from '../../templates/Learning&Development/Learning&DevelopmentTemplate'

const LD = () => {
  return (
     <LDTemplate />
  )
}

export default LD